import { useQuery } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { getRequest } from 'src/utils/request';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';

import type { RequestDataArray } from 'src/types/requestData';

const mapCityOptions = (option: UCM.CityOptionRawType): UCM.CityOptionType => ({
  value: option.code,
  label: option.name,
});

const getCityOptions = async () => {
  const { data } = await getRequest<RequestDataArray<UCM.CityOptionRawType>>(
    API.GET.cityOptions,
    {
      headers: {
        Accept: 'application/vnd.falcon.v4+json',
      },
    },
  );
  return data.data.map(({ attributes }) => mapCityOptions(attributes));
};

export const useGetCityCodeOptions = (
  config: { enabled?: boolean } = { enabled: true },
) => {
  return useQuery({
    queryKey: [QUERY_KEYS.CITY_CODE_OPTIONS],
    queryFn: getCityOptions,
    ...config,
  });
};
